import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  root: {
    display: 'block',
    marginRight: '-0.8rem',
    width: '2em',
    height: '2em',
  },
});

export default useStyles;
